<template lang="pug">
  .panel-page
    FormErrorAlert.error-alert.mx-auto(
      :message="message"
      @dismiss="message = ''"
      v-if="message")
    .panel.mx-auto
      a.back-button.body-3(@click.prevent="$emit('prevState')")
        img(src='../assets/img/back_button.svg', alt='back button')
        |  Back
      h1.mt-4 User Registration
      h5.reg-form-header.mt-4 User Registration Form
      span.body-1.agency-name-panel
        | User request for
        h5.agency-name-heading  {{ agencyName }}
      span.body-1.change-agency-panel
        a(@click="$emit('prevState')",href="#") Change Agency
      form.form(
        @submit.prevent="checkForm()"
        autocomplete="off"
      )
        #personal-section
        FormHeader.mt-3(title='PERSONAL INFORMATION', :required="true")
        .form-panel
          .form-row.mt-3
            .col-md
              .form-group
                label(required) First Name
                input.form-control(
                  v-model='firstName'
                  :class="{'is-invalid': firstNameInvalid}"
                  type='text'
                  autocomplete="stupid-crap"
                )
                FormError(v-if="firstNameInvalid", message="First name is required.")
            .col-md
              .form-group
                label(for='middleName') Middle Name
                input.form-control(
                  v-model='middleName'
                  name='middleName', type='text'
                  autocomplete="fake-crap"
                )
            .col-md
              .form-group
                label(for='lastName', required) Last Name
                input.form-control(
                  v-model='lastName'
                  :class="{'is-invalid': lastNameInvalid}"
                  name='lastName'
                  type='text'
                  autocomplete="fake-crap"
                )
                FormError(v-if="lastNameInvalid", message="Last name is required.")
          .form-row
            .col-md
              .form-group
                label(for='primaryEmail', required) Primary Email Address
                input.form-control(
                  v-model='primaryEmail'
                  :class="{'is-invalid': primaryEmailInvalid || primaryEmailIfInvalid}"
                  name='primaryEmail'
                  type='text'
                  autocomplete='fake-crap'
                )
                FormError(
                  v-if="primaryEmailInvalid || primaryEmailIfInvalid"
                  :message="emailError")
            .col-md
              .form-group
                label(for='confirmEmail', required) Confirm Email Address
                input.form-control(
                  v-model='confirmEmail'
                  :class="{'is-invalid': confirmEmailEqualInvalid || confirmEmailIfInvalid}"
                  name='confirmEmail'
                  type='text'
                  autocomplete="fake-crap"
                )
                FormError(
                  v-if="confirmEmailIfInvalid"
                  :message="emailError")
                FormError(
                  v-if="confirmEmailEqualInvalid"
                  message="Confirmation email address must match primary email address."
                )
          .form-row
            .col-md-6
              .form-group
                label(for='workPhone', required='required') Work Phone Number
                input.form-control(
                  v-model='workPhone'
                  :class="{'is-invalid': workPhoneInvalid || phoneFormatInvalid}"
                  name='workPhone'
                  type='text'
                  autocomplete="fake-crap")
                FormError(v-if="workPhoneInvalid", message="Phone number is required.")
                FormError(v-if="phoneFormatInvalid", :message="stdmsg.phoneFormatError")
          .form-row
            .col-md
              .form-group
                label(required) Supervisor's First Name
                input.form-control(
                  v-model='superFirstName'
                  :class="{'is-invalid': superFirstNameInvalid}"
                  type='text'
                  autocomplete="stupid-crap"
                )
                FormError(v-if="superFirstNameInvalid", message="Supervisor's first name is required.")
            .col-md
              .form-group
                label(for='superMiddleName') Supervisor's Middle Name
                input.form-control(
                  v-model='superMiddleName'
                  name='superMiddleName', type='text'
                  autocomplete="fake-crap"
                )
            .col-md
              .form-group
                label(for='superLastName', required) Supervisor's Last Name
                input.form-control(
                  v-model='superLastName'
                  :class="{'is-invalid': superLastNameInvalid}"
                  name='superLastName'
                  type='text'
                  autocomplete="fake-crap"
                )
                FormError(v-if="superLastNameInvalid", message="Supervisor's last name is required.")
          .form-row
            .col-md-3
              .form-group
                label(required) Supervisor's Rank
                input.form-control(
                  v-model='superRank'
                  :class="{'is-invalid': superRankInvalid}"
                  type='text'
                  autocomplete="stupid-crap"
                )
                FormError(v-if="superRankInvalid", message="Supervisor's rank is required.")
          .form-row
            .col-md-6
              .form-group
                label(for='superEmail', required) Supervisor's Email Address
                input.form-control(
                  v-model='superEmail'
                  :class="{'is-invalid': superEmailInvalid || superEmailIfInvalid}"
                  name='superEmail'
                  type='text'
                  autocomplete='fake-crap'
                )
                FormError(v-if="superEmailIfInvalid" :message="emailError")
                FormError(v-if="superEmailInvalid", message="Supervisor's email is required.")
          .form-row
            .col-md-6
              .form-group
                label(for='superPhone', required='required') Supervisor's Phone Number
                input.form-control(
                  v-model='superPhone'
                  :class="{'is-invalid': superPhoneInvalid || superPhoneFormatInvalid}"
                  name='superPhone'
                  type='text'
                  autocomplete="fake-crap")
                FormError(v-if="superPhoneInvalid", message="Supervisor's phone number is required.")
                FormError(v-if="superPhoneFormatInvalid", :message="stdmsg.phoneFormatError")
        #professional-section
        FormHeader.mt-3(title='PROFESSIONAL INFORMATION')
        .form-panel
          span.body-1
            strong User State:
            |  {{ agencyState }}
          br
          span.body-1
            strong User Agency:
            |  {{ agencyName }}
          .form-row.mt-3
            .col
              .form-group
                label(for='title') Title
                input.form-control(v-model='title', type='text', name='title')
        #account-section
        FormHeader.mt-3(title='ACCOUNT INFORMATION')
        .form-panel
          .form-row
            .col
              .form-group
                label(for='username', required='required') User Name
                input.form-control(v-model='username', :class="{'is-invalid': userNameInvalid }", type='text', name='username', aria-describedby='userNameHelpBlock')
                small#userNameHelpBlock.form-text(:class="{'text-danger': userNameInvalid,'text-muted': !userNameInvalid}") Must be at least 8 characters and should not contain &, <, >, #, +, % or /.
          .form-row
            .col-md
              .form-group
                label(for='password', required='required') Password
                input.form-control(v-model='password', :class="{'is-invalid': passwordAnyInvalid && passwordTouched}", type='password', name='password')
                FormError(v-if="passwordAnyInvalid && passwordTouched", message="Password is required and must match the criteria.")
            .col-md
              .form-group
                label(for='confirmPassword', required='required') Confirm Password
                input.form-control(v-model='confirmPassword', :class="{'is-invalid': confirmPasswordEqualInvalid}", type='password', name='confirmPassword')
                FormError(v-if="confirmPasswordEqualInvalid", message="Password confirmation must match password.")
          .row
            .col
              PasswordValidator(:length='!passwordLengthInvalid', :userName='!passwordUserNameInvalid', :firstLastName='!passwordFirstLastNameInvalid', :lowercase='!passwordLowercaseInvalid', 
                                :uppercase='!passwordUppercaseInvalid', :numeral='!passwordNumeralInvalid', :special='!passwordSpecialInvalid', :repeated='!passwordTwoConsecutiveCharactersInvalid', 
                                :consecutiveNumbers='!passwordNineConsecutiveNumbersInvalid', :blankSpace='!passwordWhitespaceInvalid')
          // If agency doesn't have an admin, then show this below
          .row
            .col-6
              .form-group
                label(for='userLevel', required='required') User Level
                select.form-control(v-model='userLevel'
                  name='userLevel'
                  :class="{'is-invalid': userLevelInvalid}")
                  option(value='')
                  option(value='agency_admin') Agency Website User Administrator
                  option(value='basic') Basic User
                FormError(
                  message="User level is required."
                  v-if="userLevelInvalid")
          .row
            .col
              .form-group
                label(for='userRole') User Role
                br
                CustomRadio(modelValue="sworn",v-model="swornValue")
                  span.body-1.ml-2 Sworn Personnel
                br
                CustomRadio(modelValue="nonsworn",v-model="swornValue")
                  span.body-1.ml-2 Non-Sworn Personnel (Civilian)
          .row
            .col
              .form-group
                label(for='iceAgent') Are you a U.S. Immigration and Customs Enforcement (ICE) Agent?
                br
                CustomRadio(:modelValue="false",v-model="iceAgent")
                  span.body-1.ml-2 No
                br
                CustomRadio(:modelValue="true",v-model="iceAgent")
                  span.body-1.ml-2 Yes
        .mt-3
          button.btn.btn-primary Review
          button.btn.btn-light.ml-3(@click.prevent="$emit('cancel')") Cancel
</template>

<script>
import FormHeader from './FormHeader.vue'
import PasswordValidator from './PasswordValidator.vue'
import CustomRadio from './CustomRadio'
import {
  mapTouched,
  mapRequired,
  mapRequiredIf,
  mapEqual,
  passwordValidators,
  phoneNumberValidators,
  validationHelpers,
} from '@/lib/validation'
import { loadForm } from '@/lib/formstore'
import stdmsg from '@/lib/stdmsg'

export default {
  name: 'RegistrationPersonalInfo',
  data: function() {
    return {
      emailError: stdmsg.emailError,
      message: '',
      ...mapTouched([
        'firstName',
        'lastName',
        'primaryEmail',
        'confirmEmail',
        'workPhone',
        'superFirstName',
        'superLastName',
        'superRank',
        'superEmail',
        'superPhone',
        'username',
        'password',
        'confirmPassword',
        'userLevel',
      ]),
      registration: '',
      agencyName: '',
      agencyState: '',
      agencyId: '',
      firstName: '',
      middleName: '',
      lastName: '',
      primaryEmail: '',
      confirmEmail: '',
      workPhone: '',
      superFirstName: '',
      superMiddleName: '',
      superLastName: '',
      superRank: '',
      superEmail: '',
      superPhone: '',
      title: '',
      username: '',
      password: '',
      confirmPassword: '',
      userLevel: '',
      userRole: '',
      swornValue: 'sworn',
      iceAgent: false,
      stdmsg,
    }
  },
  computed: {
    sworn: function() {
      return this.swornValue === 'sworn'
    },
    userNameInvalid: function() {
      return (
        (this.username.length < 8 || /[&<>#+%/]/.test(this.username)) &&
        this.usernameTouched
      )
    },
    ...mapRequired([
      'firstName',
      'lastName',
      'primaryEmail',
      'workPhone',
      'superFirstName',
      'superLastName',
      'superRank',
      'superEmail',
      'superPhone',
      'password',
      'userLevel',
      'iceAgent',
    ]),
    ...mapRequiredIf(['primaryEmail', 'confirmEmail', 'superEmail'], x =>
      /[^@]+@.+\..+/.test(x),
    ),
    ...mapEqual([
      ['confirmPassword', 'password'],
      ['confirmEmail', 'primaryEmail'],
    ]),
    ...passwordValidators('password', 'username', 'firstName', 'lastName'),
    ...phoneNumberValidators('workPhone'),
    ...phoneNumberValidators('superPhone', 'superPhoneFormatInvalid')
  },
  methods: {
    ...validationHelpers(),
    checkForm: function() {
      this.markAllTouched()
      let final = Object.keys(this._computedWatchers)
        .filter(el => /Invalid/.test(el))
        .filter(el => this[el])
      if (final.length > 0) {
        this.message = stdmsg.formError
        window.scrollTo(0, 0)
      } else {
        this.$emit('nextState')
      }
    },
  },
  mounted: loadForm(
    'registration',
    'agencyName',
    'agencyState',
    'agencyId',
    'firstName',
    'middleName',
    'lastName',
    'primaryEmail',
    'confirmEmail',
    'workPhone',
    'superFirstName',
    'superMiddleName',
    'superLastName',
    'superRank',
    'superEmail',
    'superPhone',
    'title',
    'username',
    'password',
    'confirmPassword',
    'userLevel',
    'userRole',
    'swornValue',
    'iceAgent',
  ),
  components: {
    FormHeader,
    PasswordValidator,
    CustomRadio,
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/bodies';
$width: 835px;

.error-alert {
  width: $width;
}
.back-button {
  img {
    width: 5%;
  }
}
.reg-form-header {
  color: #4d4d4d;
}
.agency-name-panel {
  padding-right: 1em;
  border-right: 2px solid #e6e6e6;
}
.agency-name-heading {
  display: inline;
}
.change-agency-panel {
  padding-left: 1em;
}
.form-panel {
  margin-top: 1em;
  background: #f8f8f8f8;
  padding: 1em 2em;
}
label {
  @extend .body-1;
}
</style>
